import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[facebookShare]'
})
export class FacebookShareDirective {
  @Input() photoUrl: string;
  @Input() description: string;

  constructor() { }

  @HostListener('click')
  onClick() {
    
      const encodedShareUrl = encodeURIComponent(window.location.href);
      const encodedPhotoUrl = encodeURIComponent(this.photoUrl);
      const encodedDescription = encodeURIComponent(this.description);

      const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedShareUrl}&picture=${encodedPhotoUrl}&description=${encodedDescription}`;
      window.open(facebookShareUrl, '_blank');
    
  }
}
